require('./mortgagePropertyValueUploaded.scss');

const PropTypes = require('prop-types');

// @ vendors
const React = require('react');
const { connect } = require('react-redux');
const { withRouter } = require('react-router-dom');

// @ commons
const { FormattedText, formatText } = require('core/i18n').i18n;

// @ components
const { ContentBox } = require('commonsComponents/contentBox');
const { OKBoxTitle } = require('commonsComponents/OKBoxTitle');
const { LoadingSection } = require('commonsComponents/loadingSection');

// @ constants
const DOCUMENTS_TYPES = require('constants/mortgageRequestDocumentsTypes');
const DOCUMENTS_NAMES = require('constants/mortgageRequestFileNames');
const { DOCUMENTS_STATUS } = require('constants/mortgageRequestHolderData');

// @ actions
const mortgageRequestEstatesActions = require('actions/mortgageRequest/mortgageRequestEstates');
const documentActions = require('actions/mortgageRequest/mortgageRequestDocumentationCenter');
const stateActions = require('actions/mortgageRequest/mortgageRequestState');

class MortgagePropertyValueUploaded extends React.Component {
    constructor(props) {
        super(props);

        this.handleOnDownloadFile = this.handleOnDownloadFile.bind(this);
        this.handleOnReturnToPanel = this.handleOnReturnToPanel.bind(this);
    }

    componentWillMount() {
        this.props.requestSummaryDocumentation();
    }

    getAppraisalFile(summaryDocsState, type) {
        const file = summaryDocsState.get('data').find(file => {
            return file.get('estado') !== DOCUMENTS_STATUS.NONE &&
                file.get('estado') !== DOCUMENTS_STATUS.PEND_APORTAR &&
                file.get('tipoDocumentoId') === type;
        });

        return file;
    }

    buildLink(fileType, fileName) {
        return (
            <a className="mortgage-property-value-uploaded__list-item-link"
                href="#"
                onClick={(evt) => this.handleOnDownloadFile(evt, fileType)}
            >
                {fileName}
            </a>
        );
    }

    handleOnDownloadFile(evt, type) {
        evt.preventDefault();

        this.props.requestDocument({
            documentType: type
        });
    }

    handleOnReturnToPanel(evt) {
        evt.preventDefault();
        this.props.requestState('/myprofile/mortgage/panel', this.props.history)
    }

    render() {
        const { summaryDocsState } = this.props

        if (summaryDocsState.get('isFetching') || !summaryDocsState.get('documentsRequested')) {
            return <LoadingSection />;
        }

        const fileCERT = this.getAppraisalFile(summaryDocsState, DOCUMENTS_TYPES.TAS_CERT_CLI);

        const linkTAS = this.buildLink(DOCUMENTS_TYPES.TAS_CLI, DOCUMENTS_NAMES.TAS_CLI);
        const linkCERT = fileCERT ? this.buildLink(DOCUMENTS_TYPES.TAS_CERT, DOCUMENTS_NAMES.TAS_CERT_CLI) : '';

        const certificateHtml = fileCERT && (
            <div className="col-md-12 mortgage-property-value-uploaded__list-item">
                <span className="mortgage-property-value-uploaded__list-item-label">
                    <FormattedText value="mortgagePropertyValue-uploadAppraisalCertSubitle" />
                </span>
                {linkCERT}
            </div>
        );

        return (
            <div className="mortgage-property-value-uploaded">
                <ContentBox>
                    <div className="row">
                        <div className="col-md-2">
                            <i className="mortgage-property-value-uploaded__icon-success" />
                        </div>
                        <div className="col-md-10 mortgage-property-value-uploaded__content">
                            <OKBoxTitle
                                value={formatText('mortgagePropertyValueUploaded-subtitle')}
                                size="medium"
                            />
                            <div className="row no-outside-gutter">
                                <div className="col-md-12 mortgage-property-value-uploaded__list">
                                    <div className="col-md-12 mortgage-property-value-uploaded__list-item">
                                        <span className="mortgage-property-value-uploaded__list-item-label">
                                            <FormattedText value="mortgagePropertyValue-uploadAppraisalSubitle" />
                                        </span>
                                        {linkTAS}
                                    </div>
                                    {certificateHtml}
                                </div>
                            </div>
                            <div className="row no-outside-gutter">
                                <div className="col-md-12 mortgage-property-value-uploaded__text">
                                    <p>{formatText('mortgagePropertyValueUploaded-text1')}</p>
                                </div>
                            </div>
                            <div className="row no-outside-gutter mortgage-property-value-uploaded__footer">
                                <div className="col-md-5">
                                    <a href="#" className="ok-link" onClick={this.handleOnReturnToPanel}>
                                        {formatText('mortgagePropertyValueUploaded-backToPanelLink')}
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </ContentBox>
            </div>
        );
    }
}

MortgagePropertyValueUploaded.propTypes = {
    summaryDocsState: PropTypes.object,
    requestSummaryDocumentation: PropTypes.func,
    requestDocument: PropTypes.func,
    requestState: PropTypes.func,
    history: PropTypes.object.isRequired,
};

module.exports.constructor = MortgagePropertyValueUploaded;

module.exports.MortgagePropertyValueUploaded = withRouter(connect(state => ({
    summaryDocsState: state.mortgageRequestSummaryDocumentation
}), {
    requestSummaryDocumentation: mortgageRequestEstatesActions.fetchSimpleNotes,
    requestDocument: documentActions.getDocument,
    requestState: stateActions.requestState
})(MortgagePropertyValueUploaded));
